/**
 * @generated SignedSource<<9db454856b4e75e1ada80b17b089e483>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DurationBasedAgendaHeaderFragment_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly id?: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedFiltersModal_session">;
  readonly " $fragmentType": "DurationBasedAgendaHeaderFragment_session";
};
export type DurationBasedAgendaHeaderFragment_session$key = {
  readonly " $data"?: DurationBasedAgendaHeaderFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedAgendaHeaderFragment_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DurationBasedAgendaHeaderFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DurationBasedFiltersModal_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Customer",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Member",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "f32223882d35feb32fc48c1f5f3e241c";

export default node;
